"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=erc-1155.js.map